import { useAppSelector } from '@hooks/reduxHooks';
import { $api } from '@service/RequestService';
import { Permissions } from '@utils/constants/permissions';
import { useQuery } from 'react-query';

import { queryKeys } from '../constants';
import { IAutoTaskConfig } from '../models';

export const useAutoTaskConfig = () => {
  const permissions = useAppSelector(state => state.userReducer.user?.role.permissions);
  const isAccessSettingsBotAutoTask = permissions?.includes(Permissions.PERMISSION_SETTINGS_AUTO_TASK);

  return useQuery<IAutoTaskConfig>({
    queryKey: [queryKeys.AUTO_TASK_CONFIG],
    queryFn: async () => {
      const res = await $api.get('/v1/auto-task-setting');

      return res?.data?.data;
    },
    enabled: isAccessSettingsBotAutoTask
  });
};
